import { useIsNMIApplication } from "@faire/deprecated-retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/useIsNMIApplication";
import { useStrictLocalization } from "@faire/web/common/localization";

export const useOwFSectionTitles = () => {
  const { strictLocalize } = useStrictLocalization();
  const { isNMIApplication } = useIsNMIApplication();

  const basicInformation = isNMIApplication
    ? strictLocalize({
        id: "yn0uaV",
        defaultMessage: "Personal information",
        description: {
          text: "Title for one section of the Open with Faire application form. The resulting translation should be in Sentence case eg. 'Personal information' and not 'Personal Information'",
          img: "https://cdn.faire.com/fastly/76429c2b6051f484da05d0ca4521f83c0af768f2ce2f6868916166d3b45052f0.png",
        },
      })
    : strictLocalize({
        id: "LiAGm6",
        defaultMessage: "Basic information",
        description: {
          text: "Title for one section of the Open with Faire application form. The resulting translation should be in Sentence case eg. 'Basic information' and not 'Basic Information'",
          img: "https://cdn.faire.com/fastly/5929aa7173e756cd970b4a998025e30409576c12555946d64f9e315533d5bfea.png",
        },
      });
  const storeInformation = strictLocalize({
    id: "BaFjP1",
    defaultMessage: "Store information",
    description: {
      text: "Title for one section of the Open with Faire application form. The resulting translation should be in Sentence case eg. 'Store information' and not 'Store Information'",
      img: "https://cdn.faire.com/fastly/517bea738b233374483a06830aa4876c16de854097a7c8f774e8ebdfb7f1b47f.png",
    },
  });
  const financialInformation = strictLocalize({
    id: "96+wYa",
    defaultMessage: "Financial information",
    description: {
      text: "Title for one section of the Open with Faire application form. The resulting translation should be in Sentence case eg. 'Financial information' and not 'Financial Information'",
      img: "https://cdn.faire.com/fastly/af16940aff9274f99ef267da2ced478ab7f848452cfedeb039197db5b00a8a04.png",
    },
  });
  const additionalInformation = strictLocalize({
    id: "VHhQ2V",
    defaultMessage: "Additional information",
    description: {
      text: "Title for one section of the Open with Faire application form. The resulting translation should be in Sentence case eg. 'Additional information' and not 'Additional Information'. It is an optional section.",
      img: "https://cdn.faire.com/fastly/4fe50d0d313264778fe389e0a25aad78bd9dd2f39a6fe10761e067c26eeed978.png",
    },
  });
  const optionalInformation = strictLocalize({
    id: "bQTai4",
    defaultMessage: "Optional information",
    description: {
      text: "Title for one section of the Open with Faire application form. The resulting translation should be in Sentence case eg. 'Optional information' and not 'Optional Information'. It is an optional section.",
      img: "https://cdn.faire.com/fastly/8837e4355c4e96622fb54847710dbe80fe581996a7a52241c87785d4dadfd627.png",
    },
  });
  const optionalInformationSubtitle = strictLocalize({
    id: "nsihl7",
    defaultMessage:
      "Answering these now may reduce the need for follow-ups later.",
    description: {
      text: "Subtitle for one section of the Open with Faire application form. It is an optional section.",
      img: "https://cdn.faire.com/fastly/8837e4355c4e96622fb54847710dbe80fe581996a7a52241c87785d4dadfd627.png",
    },
  });

  return {
    basicInformation,
    storeInformation,
    financialInformation,
    additionalInformation,
    optionalInformation,
    optionalInformationSubtitle,
  };
};
